import { render, staticRenderFns } from "./shieldHalvedIcon.vue?vue&type=template&id=b73d8256"
import script from "./shieldHalvedIcon.vue?vue&type=script&lang=js"
export * from "./shieldHalvedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports